import wasm from "../../build/psp.async.wasm";
export default wasm;
